// DS1.10.1
// DS1.10.2
// DS1.10.3
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { useReverseTheme } from '@wix/da-react-context/pkg/ThemeContext';
import React from 'react';
import { usePopoverOnInteraction } from '../../../popper/hooks/usePopoverOnInteraction';
import SophisticatedTooltipBase from '../../lego/SophisticatedTooltipBase';
/**
 * A more sophisticated tooltip than SimpleTooltip. This handles the expected UX for a standard tooltip.
 *
 * If `heading` isn't supplied, `aria-label` is required to fulfill a11y requirements.
 *
 * If you want an FTUE tooltip, consider using `SophisticatedFtueTooltip` instead.
 */ const SophisticatedTooltip = (_param)=>{
    var { isVisible: forceVisible  } = _param, rest = _object_without_properties(_param, [
        "isVisible"
    ]);
    const isForcingVisibility = forceVisible !== undefined;
    const shouldListenForEvents = !isForcingVisibility;
    const { isVisible , onClick , onMouseEnter , onMouseLeave , onClose  } = usePopoverOnInteraction({
        listenOnClicks: shouldListenForEvents,
        listenOnHover: shouldListenForEvents,
        hideOnScroll: shouldListenForEvents
    });
    const reverseTheme = useReverseTheme();
    return isForcingVisibility ? /*#__PURE__*/ React.createElement(SophisticatedTooltipBase, _extends({
        isVisible: forceVisible,
        forceTheme: reverseTheme
    }, rest)) : /*#__PURE__*/ React.createElement(SophisticatedTooltipBase, _extends({
        isVisible: isVisible,
        forceTheme: reverseTheme,
        onReferenceClick: onClick,
        onReferenceMouseEnter: onMouseEnter,
        onReferenceMouseLeave: onMouseLeave,
        onClose: onClose
    }, rest));
};
SophisticatedTooltip.displayName = 'SophisticatedTooltip';
export default SophisticatedTooltip;
